import React, { useState } from 'react';
import { Tabs } from './bpm';
import './Synthese.css';

const Synthese = ({ onLogoClick = null }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: 'Vue d\'ensemble',
      content: (
        <div className="synthese-tab-content">
          <p>Vue d'ensemble du portefeuille</p>
        </div>
      )
    },
    {
      label: 'Performance',
      content: (
        <div className="synthese-tab-content">
          <p>Analyse de performance</p>
        </div>
      )
    },
    {
      label: 'Répartition',
      content: (
        <div className="synthese-tab-content">
          <p>Répartition des actifs</p>
        </div>
      )
    }
  ];

  return (
    <div className="synthese-page">
      <Tabs 
        tabs={tabs}
        defaultTab={activeTab}
        onChange={setActiveTab}
      />
    </div>
  );
};

export default Synthese;














